import React from "react";

export const ViewOnlyContext = React.createContext(false);

export const useViewOnly = () => {
  const viewOnly = React.useContext(ViewOnlyContext);
  return viewOnly;
};
